var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembershipchanges({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#000",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 1.391
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.13 4.87 1.044 1.043L6.957 3.13M3.13 11.826l1.044 1.044 2.783-2.783M9.043 5.565h4.174M9.043 11.826h4.174"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipchanges);
export default __webpack_public_path__ + "static/media/membershipchanges.84486d5796e6356c4cebfa0e92c3cd00.svg";
export { ForwardRef as ReactComponent };